import * as React from "react";
import { Text as DefaultText } from "react-native";
import useThemeColor from "../../hooks/useThemeColor";

type _TextProps = {
  lightColor?: string;
  darkColor?: string;
  size?: number;
  //          200,         300,       400,        500,        600,       700,       800,        900
  weight?:
    | "ExtraLight"
    | "Light"
    | "Regular"
    | "Medium"
    | "SemiBold"
    | "Bold"
    | "ExtraBold"
    | "Black";
  flipColor?: boolean;
  lineHeight?: number;
};

export type TextProps = _TextProps & DefaultText["props"];

export default function Text(props: TextProps) {
  const {
    style,
    lightColor,
    darkColor,
    size = 14,
    weight = "normal",
    flipColor = false,
    lineHeight = 20,
    ...otherProps
  } = props;
  const color = useThemeColor({ light: lightColor, dark: darkColor }, "text");
  const fontFamily = weight === "normal" ? "NunitoRegular" : `Nunito${weight}`;

  return (
    <DefaultText
      style={[
        { color, fontFamily: fontFamily, fontSize: size, lineHeight },
        style,
      ]}
      allowFontScaling={false}
      maxFontSizeMultiplier={1}
      {...otherProps}
    />
  );
}
